module.exports = __webpack_public_path__ + "media/fundraising_sim/plus_img-sp02-83de8c55.png";